import React from 'react';

import { AiAssistantDisclaimerKey } from './ai-assistant-disclaimers';

const assistantTitles: Record<AiAssistantDisclaimerKey, string> = {
  'ai-supervisor': 'заключение ИИ-супервизора',
  'ai-abstract': 'ИИ-конспект',
  'ai-homework': 'ИИ домашнее задание',
  'ai-metaphor': 'ИИ метафоры',
  'ai-mac-technique': 'ИИ МАК технику',
  'ai-therapy-plan': 'ИИ план терапии',
  'ai-coach-supervisor': 'рекомендации коуч супервизора',
  'ai-tales-therapist': 'рекомендации ИИ Cказкотерапевта',
  'ai-transcription': 'транскрипцию',
};

type Props = {
  assistant: AiAssistantDisclaimerKey;
  showTariffLine?: boolean;
  isGroupConsultation?: boolean;
};

export const AiAssistantMissingMessage = ({ assistant, showTariffLine = true, isGroupConsultation = false }: Props) => {
  const title = assistantTitles[assistant];

  return (
    <div className="space-y-3 text-blackBase font-manrope text-sm lg:text-base leading-relaxed">
      <p className="font-semibold text-lg">Почему я не вижу {title}?</p>
      <p>
        Если после завершения сессии {title} не отображается, пожалуйста, проверьте следующие пункты. Чек-лист поможет
        понять, почему ассистент пока не сформировал ответ:
      </p>
      <ul className="space-y-1">
        {showTariffLine && <li>✅ Ваш тариф: ПРИМА, ТЕРЦИЯ, КВИНТА или ОКТАВА?</li>}
        <p>✅ Вы включили ИИ-супервизор во время сессии?</p>
        <p>
          ✅{' '}
          {isGroupConsultation
            ? 'Для встречи получено согласие на работу ИИ?'
            : 'Клиент дал согласие на работу ИИ?'}
        </p>
        <p>✅ Прошло ли более 5 минут с момента окончания сессии?</p>
      </ul>
      <p>
        Если вы проверили все пункты, но ассистент так и не отобразился, пожалуйста, обратитесь в службу поддержки{' '}
        <a href="mailto:info@zingizi.pro" className="underline text-redBase">
          info@zingizi.pro
        </a>
        <p>Мы поможем разобраться.</p>
      </p>
    </div>
  );
};
